import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Produto from '../produto/produto';
import ConfirmModal from '../common/modal/confirmModal';

import {
	setModoTela, initForm, excluir, salvarItem,
	getLista, excluirItem, getListaItens, getListaItensHistorico, gerarPdf, 
	enviar
} from './pedidoActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { read } from 'fs';
import DateFormat from '../common/dateFormat/DateFormat';

class PedidoForm extends Component {

	state = {

	}

	componentDidMount() {
		if (!this.props.formularioValues.historico) {
			this.props.getListaItens(this.props.formularioValues.id);
		} else {
			this.props.getListaItensHistorico(this.props.formularioValues.id_pedido);
		}

		document.addEventListener('keydown', this.handleKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyDown);

		if (!this.props.formularioValues.historico) {
			this.props.getListaItens(0);
		} else {
			this.props.getListaItensHistorico(0);
		}
	}

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setModalProduto(null);
		}
	};

    render() {
		
		let readOnly = this.props.formularioValues.finalizado ? 'readOnly' : '';

		//Primeiro de tudo deve selecionar o cliente
		if (!this.props.formularioValues.historico) {
			if (!this.props.formularioValues.id) {
				return this.selecionarCliente();
			} else if (this.props.formularioValues.alterarPedido) {
				return this.alterarPedido();
			} else if (this.props.formularioValues.selecionarProduto) {
				return this.selecionarProduto();
			}
		}

		const validarBoleto = !this.props.formularioValues.historico && this.props.formularioValues.id_cliente && !this.props.formularioValues.finalizado;
		const boletoPendente = !this.props.formularioValues.historico && validarBoleto && this.props.listaBoletosPendentes.filter(boleto => boleto.id_cliente == this.props.formularioValues.id_cliente
			&& boleto.vencido && !boleto.cartorio && !boleto.protesto).length > 0;
		const boletoVencido = !this.props.formularioValues.historico && validarBoleto && this.props.listaBoletosPendentes.filter(boleto => boleto.id_cliente == this.props.formularioValues.id_cliente && boleto.vencido).length > 0;
		const boletoCartorio = !this.props.formularioValues.historico && validarBoleto && this.props.listaBoletosPendentes.filter(boleto => boleto.id_cliente == this.props.formularioValues.id_cliente && boleto.cartorio).length > 0;
		const boletoProtesto = !this.props.formularioValues.historico && validarBoleto && this.props.listaBoletosPendentes.filter(boleto => boleto.id_cliente == this.props.formularioValues.id_cliente && boleto.protesto).length > 0;

		let totalGeralNF = 0;
		for (let i = 0; i < this.props.listaItens.length; i++) {
			const item = this.props.listaItens[i];

			const quantidade = parseFloat(item.quantidade || 0);
			const valorLiquido = parseFloat(item.valor_bruto || 0) - parseFloat(item.vlr_desconto || 0);
			const valorUnitarioLiquido = quantidade > 0 ? valorLiquido / quantidade : 0;
			const totalNF = parseFloat(item.quantidade_nf) * valorUnitarioLiquido;

			totalGeralNF += totalNF;
		}

		return (
			<div style={{ paddingBottom: 50 }}>
				{(!readOnly && !this.state.modalProduto) &&
				<button
					onClick={() => {
						if (!readOnly) {
							this.props.initForm({
								...this.props.formularioValues,
								selecionarProduto: true
							});
						}
					}}
					style={{
						position: 'fixed',
						right: 20,
						bottom: 20,
						width: 56,
						height: 56,
						borderRadius: '50%',
						border: 'none',
						background: '#28a745',
						opacity: readOnly ? 0.5 : null,
						color: '#fff',
						fontSize: 24,
						fontWeight: 'bold',
						boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
						zIndex: 9999,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<i
						className='fa fa-plus'
						style={{
							fontSize: 24
						}}
					/>
				</button>}

				{this.state.confirmacao &&
				<ConfirmModal
					visible={this.state.confirmacao}
					titulo='Confirmação'
					mensagem={this.state.confirmacao.mensagem}
					textoConfirmar='Sim'
					textoCancelar='Não'
					onConfirm={this.state.confirmacao.eventoSim}
					onCancel={this.state.confirmacao.eventoCancelar}
				/>}

				{this.modalProduto(readOnly)}

				<Form event={this.props.handleSubmit}>
					<div
						style={{
							backgroundColor: '#f8f9fc',
							borderRadius: 2,
							padding: 16,
							border: '1px solid #e5e7eb',
							boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
							position: 'relative'
						}} >
						{/* BOTÃO EDITAR */}
						<button
							type='button'
							onClick={() => {
								if (!readOnly) {
									this.props.initForm({
										...this.props.formularioValues,
										alterarPedido: true
									});
								}
							}}
							style={{
								position: 'absolute',
								top: 4,
								right: 4,
								width: 32,
								height: 32,
								borderRadius: '50%',
								border: '1px solid #dcdcdc',
								backgroundColor: readOnly ? '#f1f1f1' : '#ffc107',
								color: readOnly ? '#9e9e9e' : '#fff',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								boxShadow: readOnly
									? 'none'
									: '0 2px 6px rgba(0,0,0,0.2)',
								cursor: readOnly ? 'not-allowed' : 'pointer',
								pointerEvents: readOnly ? 'none' : 'auto',
								filter: readOnly ? 'grayscale(100%)' : 'none',
								transition: 'all 0.2s ease'
							}} >
							<i
								className='fas fa-pencil-alt'
								style={{
									fontSize: 13
								}}
							/>
						</button>
						<button
							type='button'
							onClick={() => {
								if (!readOnly && window.confirm('Deseja realmente excluir o pedido?')) {
									this.props.excluir({
										...this.props.formularioValues
									});
								}
							}}
							style={{
								position: 'absolute',
								top: 40,
								right: 4,
								width: 32,
								height: 32,
								borderRadius: '50%',
								border: '1px solid #dcdcdc',
								backgroundColor: readOnly ? '#f1f1f1' : '#dc3545',
								color: readOnly ? '#9e9e9e' : '#fff',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								boxShadow: readOnly
									? 'none'
									: '0 2px 6px rgba(0,0,0,0.2)',
								cursor: readOnly ? 'not-allowed' : 'pointer',
								pointerEvents: readOnly ? 'none' : 'auto',
								filter: readOnly ? 'grayscale(100%)' : 'none',
								transition: 'all 0.2s ease'
							}} >
							<i
								className='fas fa-trash-alt'
								style={{
									fontSize: 13
								}}
							/>
						</button>

						<button
							type='button'
							onClick={() => {
								if (!readOnly && window.confirm('Após enviar nenhuma alteração poderá ser realizada. Deseja realmente enviar o pedido?')) {
									this.props.enviar({
										...this.props.formularioValues
									});
								}
							}}
							style={{
								position: 'absolute',
								top: 76,
								right: 4,
								width: 32,
								height: 32,
								borderRadius: '50%',
								border: '1px solid #dcdcdc',
								backgroundColor: readOnly ? '#f1f1f1' : '#28a745',
								color: readOnly ? '#9e9e9e' : '#fff',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								boxShadow: readOnly
									? 'none'
									: '0 2px 6px rgba(0,0,0,0.2)',
								cursor: readOnly ? 'not-allowed' : 'pointer',
								pointerEvents: readOnly ? 'none' : 'auto',
								filter: readOnly ? 'grayscale(100%)' : 'none',
								transition: 'all 0.2s ease'
							}} >
							<i
								className='fas fa-file-upload'
								style={{
									fontSize: 13
								}}
							/>
						</button>

						<button
							type='button'
							onClick={() => {
								this.setState({
									confirmacao: {
										mensagem: 'Deseja imprimir com as imagens?',
										eventoSim: () => {
											this.props.gerarPdf({
												...this.props.formularioValues,
												imprimir_imagens: true
											}, this.props.listaItens);
											this.setState({
												confirmacao: null
											});
										},
										eventoCancelar: () => {
											this.props.gerarPdf({
												...this.props.formularioValues,
												imprimir_imagens: false
											}, this.props.listaItens);
											this.setState({
												confirmacao: null
											});
										}
									}
								});
							}}
							style={{
								position: 'absolute',
								top: 112,
								right: 4,
								width: 32,
								height: 32,
								borderRadius: '50%',
								border: '1px solid #dcdcdc',
								backgroundColor: '#1976d2',
								color: '#fff',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
								cursor: 'pointer',
								pointerEvents: 'auto',
								filter: 'none',
								transition: 'all 0.2s ease'
							}} >
							<i
								className='fas fa-file-pdf'
								style={{
									fontSize: 13
								}}
							/>
						</button>

						<button
							type='button'
							onClick={() => {
								this.props.setModoTela('lista');
							}}
							style={{
								position: 'absolute',
								top: 148,
								right: 4,
								width: 32,
								height: 32,
								borderRadius: '50%',
								border: 'none',
								backgroundColor: '#7d7d7d',
								color: '#fff',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
							}} >
							<i
								className='fas fa-arrow-left'
								style={{
									fontSize: 13
								}}
							/>
						</button>

						<div
							style={{
								fontSize: 14,
								fontWeight: 'bold',
								color: '#222',
								lineHeight: 1.3,
								marginBottom: 4
							}} >
							{this.props.formularioValues.razao_social_cliente || '-'}
						</div>

						<div
							style={{
								fontSize: 12,
								color: '#666',
								marginBottom: 4
							}} >
							{this.props.formularioValues.nome_fantasia_cliente || '-'}
						</div>
						<div style={{ display: 'flex', flexDirection: 'row' }}>
							<div
								style={{
									flex: 1,
									minWidth: '50%'
								}} >
								<div
									style={{
										fontSize: 10,
										color: '#999'
									}} >
									Código
								</div>
								<div
									style={{
										fontWeight: '600',
										fontSize: 12,
										color: '#333',
										marginBottom: 4
									}} >
									{this.props.formularioValues.codigo_cliente || '-'}
								</div>
							</div>
							<div
								style={{
									flex: 1,
									minWidth: '50%'
								}} >

								<div
									style={{
										fontSize: 10,
										color: '#999'
									}} >
									CNPJ / CPF
								</div>
								<div
									style={{
										fontWeight: '600',
										fontSize: 12,
										color: '#333',
										marginBottom: 4
									}} >
									{this.props.formularioValues.cnpj_cliente || this.props.formularioValues.cpf_cliente || '-'}
								</div>
							</div>
						</div>
						<div style={{ display: 'flex', flexDirection: 'row' }}>
							<div
								style={{
									flex: 1,
									minWidth: '50%'
								}} >
								<div
									style={{
										fontSize: 10,
										color: '#999'
									}} >
									Forma de Pagamento
								</div>
								<div
									style={{
										fontWeight: '600',
										fontSize: 12,
										color: '#333',
										marginBottom: 4
									}} >
									{this.props.formularioValues.nome_forma_pagamento || 'Não Informada'}
								</div>
							</div>						
							<div
								style={{
									flex: 1,
									minWidth: '50%'
								}} >
								<div
									style={{
										fontSize: 10,
										color: '#999'
									}} >
									Tipo do Pagamento
								</div>
								<div
									style={{
										fontWeight: '600',
										fontSize: 12,
										color: '#333',
										marginBottom: 4
									}} >
									{this.props.formularioValues.nome_tipo_pagamento || 'Não Informado'}
								</div>
							</div>
						</div>
						<div style={{ display: 'flex', flexDirection: 'row' }}>
							<div
								style={{
									flex: 1,
									minWidth: '100%'
								}} >
								<div
									style={{
										fontSize: 10,
										color: '#999'
									}} >
									Observação
								</div>
								<div
									style={{
										fontWeight: '600',
										fontSize: 12,
										color: '#333',
										marginBottom: 4,
										whiteSpace: 'pre-line'
									}} >
									{this.props.formularioValues.obs || 'Sem Observação'}
								</div>
							</div>
						</div>
						<div style={{ display: 'flex', flexDirection: 'row' }}>
							<div
								style={{
									flex: 1,
									minWidth: '25%'
								}} >
								<div
									style={{
										fontSize: 10,
										color: '#999'
									}} >
									Data
								</div>
								<div
									style={{
										fontWeight: '600',
										fontSize: 12,
										color: '#333',
										marginBottom: 4
									}} >
									{DateFormat.formatarDataSqlParaTela(this.props.formularioValues.datahora_pedido)}
								</div>
							</div>
							<div
								style={{
									flex: 1,
									minWidth: '28%'
								}} >
								<div
									style={{
										fontSize: 10,
										color: '#999'
									}} >
									Total do Pedido
								</div>
								<div
									style={{
										fontWeight: '600',
										fontSize: 12,
										color: '#333',
										marginBottom: 4
									}} >
									R$ {FormatUtils.formatarValorTela(this.props.formularioValues.total_pedido, 2)}
								</div>
							</div>

							<div
								style={{
									flex: 1,
									minWidth: '24%'
								}} >
								<div
									style={{
										fontSize: 10,
										color: '#999'
									}} >
									Total da NF
								</div>
								<div
									style={{
										fontWeight: '600',
										fontSize: 12,
										color: '#333',
										marginBottom: 4
									}} >
									R$ {FormatUtils.formatarValorTela(totalGeralNF, 2)}
								</div>
							</div>
							<div
								style={{
									flex: 1,
									minWidth: '19%'
								}} >
								<div
									style={{
										fontSize: 10,
										color: '#999'
									}} >
									Status
								</div>
								<div
									style={{
										fontWeight: '600',
										fontSize: 12,
										color: this.props.formularioValues.finalizado ? '#076e00' : '#bdbf00',
										marginBottom: 4
									}} >
									{this.props.formularioValues.nome_status}
								</div>
							</div>
						</div>

						<div
							style={{
								display: 'flex',
								flexWrap: 'wrap',
								gap: 8,
								marginTop: 8
							}} >
							{boletoPendente &&
								<div
									style={{
										backgroundColor: '#fff3cd',
										color: '#856404',
										border: '1px solid #ffe69c',
										borderRadius: 20,
										padding: '6px 12px',
										fontSize: 10,
										fontWeight: 'bold',
										display: 'flex',
										alignItems: 'center',
										gap: 6
									}} >
									<i className='fas fa-file-invoice-dollar' />
									Cobrança em Aberto
								</div>}
							{boletoVencido &&
								<div
									style={{
										backgroundColor: '#ff2b2b',
										color: '#ffffff',
										border: '1px solid #ff2b2b',
										borderRadius: 20,
										padding: '6px 12px',
										fontSize: 10,
										fontWeight: 'bold',
										display: 'flex',
										alignItems: 'center',
										gap: 6
									}} >
									<i className='fas fa-calendar-times' />
									Cobrança Vencida
								</div>}

							{boletoCartorio &&
								<div
									style={{
										backgroundColor: '#ff2b2b',
										color: '#ffffff',
										border: '1px solid #ff2b2b',
										borderRadius: 20,
										padding: '6px 12px',
										fontSize: 10,
										fontWeight: 'bold',
										display: 'flex',
										alignItems: 'center',
										gap: 6
									}} >
									<i className='fas fa-envelope-open-text' />
									Cobrança em Cartório
								</div>}
							{boletoProtesto &&
								<div
									style={{
										backgroundColor: '#ff2b2b',
										color: '#ffffff',
										border: '1px solid #ff2b2b',
										borderRadius: 20,
										padding: '6px 12px',
										fontSize: 10,
										fontWeight: 'bold',
										display: 'flex',
										alignItems: 'center',
										gap: 6
									}} >
									<i className='fa fa-gavel' />
									Cobrança em Protesto
								</div>}

						</div>
					</div>

					{this.produtos(readOnly)}
				</Form>
			</div>
		);
    }

	selecionarCliente() {
	
		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Select
								name='id_cliente'
								options={this.props.listaCliente}
								label='Cliente' placeholder='Informe'
								cols='12 12 12 12'
								value={this.props.formularioValues.id_cliente}
								onChange={value => {
									const cliente = this.props.listaCliente.filter(item => item.id_cliente == value)[0];

									this.props.initForm({
										...this.props.formularioValues,
										id_cliente: cliente ? cliente.id_cliente : null,
										codigo_cliente: cliente ? cliente.codigo : null,
										cnpj_cliente: cliente ? cliente.cnpj : null,
										cpf_cliente: cliente ? cliente.cpf : null,
										razao_social_cliente: cliente ? cliente.razao_social : null,
										nome_fantasia_cliente: cliente ? cliente.nome_fantasia : null,
										id_vendedor: cliente ? cliente.id_vendedor : null,
										codigo_vendedor: cliente ? cliente.codigo_vendedor : null
									});
								}} />

							{(!this.props.formularioValues.id && this.props.formularioValues.id_cliente) &&
							<>
								<Field
									name='codigo_cliente'
									component={LabelAndInput}
									label='Código' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={'readOnly'} />

								<Field
									name='razao_social_cliente'
									component={LabelAndInput}
									label='Razão Social' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={'readOnly'} />
								
								<Field
									name='nome_fantasia_cliente'
									component={LabelAndInput}
									label='Nome Fantasia' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={'readOnly'} />
						
								{this.props.formularioValues.cnpj_cliente &&
								<Field
									name='cnpj_cliente'
									component={LabelAndInputMask}
									label='CNPJ' placeholder='Informe'
									cols='12 12 12 12'
									minWidth={220}
									readOnly={'readOnly'}
									mask='99.999.999/9999-99' />}
							
								{this.props.formularioValues.cpf_cliente &&
								<Field
									name='cpf_cliente'
									component={LabelAndInputMask}
									label='CPF' placeholder='Informe'
									cols='12 12 12 12'
									minWidth={180}
									readOnly={'readOnly'}
									mask='999.999.999-99' />}
							</>}
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								<Button
									text='Confirmar'
									submit
									type={'success'}
									icon={'fa fa-check'}
									disabled={!this.props.formularioValues.id_cliente} />
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => {
										if (this.props.formularioValues.id_cliente) {
											this.props.initForm({
												...this.props.formularioValues,
												id_cliente: null,
												codigo_cliente: null,
												cnpj_cliente: null,
												cpf_cliente: null,
												razao_social_cliente: null,
												nome_fantasia_cliente: null
											});
										} else {
											this.props.setModoTela('lista');
										}
									}} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

	alterarPedido() {
	
		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>					
						<Row>
							<Field
								name='codigo_cliente'
								component={LabelAndInput}
								label='Código' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'} />

							<Field
								name='razao_social_cliente'
								component={LabelAndInput}
								label='Razão Social' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'} />

							<Field
								name='nome_fantasia_cliente'
								component={LabelAndInput}
								label='Nome Fantasia' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'} />

							{this.props.formularioValues.cnpj_cliente &&
							<Field
								name='cnpj_cliente'
								component={LabelAndInputMask}
								label='CNPJ' placeholder='Informe'
								cols='12 12 12 12'
								minWidth={220}
								readOnly={'readOnly'}
								mask='99.999.999/9999-99' />}

							{this.props.formularioValues.cpf_cliente &&
							<Field
								name='cpf_cliente'
								component={LabelAndInputMask}
								label='CPF' placeholder='Informe'
								cols='12 12 12 12'
								minWidth={180}
								readOnly={'readOnly'}
								mask='999.999.999-99' />}

							<Select
								name='id_forma_pagamento'
								options={this.props.listaFormaPagamento}
								label='Forma de Pagamento' placeholder='Informe'
								cols='12 12 12 12'
								value={this.props.formularioValues.id_forma_pagamento}
								onChange={value => {
									const forma = this.props.listaFormaPagamento.filter(item => item.id_forma_pagamento == value)[0];

									this.props.initForm({
										...this.props.formularioValues,
										id_forma_pagamento: forma ? forma.id_forma_pagamento : null,
										nome_forma_pagamento: forma ? forma.descricao : null
									});
								}} />

							<Select
								name='id_tipo_pagamento'
								options={this.props.listaTipoPagamento}
								label='Tipo do Pagamento' placeholder='Informe'
								cols='12 12 12 12'
								value={this.props.formularioValues.id_tipo_pagamento}
								onChange={value => {
									const tipo = this.props.listaTipoPagamento.filter(item => item.id_tipo_pagamento == value)[0];

									this.props.initForm({
										...this.props.formularioValues,
										id_tipo_pagamento: tipo ? tipo.id_tipo_pagamento : null,
										nome_tipo_pagamento: tipo ? tipo.descricao : null
									});
								}} />

							<Field
								name='obs'
								component={LabelAndTextarea}
								label='Observação' placeholder='Informe'
								cols='12 12 12 12' />
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => {
										this.props.initForm({
											...this.props.formularioValues,
											alterarPedido: false
										});
									}} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

	produtos(readOnly) {
		return (
			<div>

				<h6 style={{ marginTop: 8, marginLeft: 2 }}>Produtos ({this.props.listaItens.length})</h6>

				{this.props.listaItens.map((item, i) => (

					<div
						key={item.id_pedido}
						style={{
							backgroundColor: '#fff',
							borderRadius: 16,
							marginBottom: 4,
							padding: 16,
							boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
							border: this.state.linhaSelecionada == item.id_produto
								? '2px solid #5b7fff'
								: '1px solid #e5e5e5'
						}}
						onClick={e => {
							e.stopPropagation();

							this.setModalProduto({
								...item,
								quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
								quantidade_nf: FormatUtils.formatarValorTela(item.quantidade_nf, 2),
								vlr_unitario: FormatUtils.formatarValorTela(item.vlr_unitario, 2),
								vlr_desconto: FormatUtils.formatarValorTela(item.vlr_desconto, 2),
								perc_desconto: FormatUtils.formatarValorTela(item.perc_desconto, 2),
								valor_bruto: FormatUtils.formatarValorTela(item.valor_bruto, 2)
							});
						}} >
						<div
							style={{
								fontSize: 14,
								fontWeight: 'bold',
								color: '#333'
							}}
						>
							{item.descricao}
						</div>
						<div
							style={{
								fontSize: 14,
								fontWeight: 'bold',
								color: '#333'
							}}
						>
							{item.nome_produto}
						</div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between'
							}} >
							<div style={{ fontSize: 10 }}>
								<div style={{ color: '#999' }}>
									Código
								</div>
								<div style={{ fontWeight: 600 }}>
									{item.codigo_produto}
								</div>
							</div>

							<div style={{ textAlign: 'right', fontSize: 10 }}>
								<div style={{ color: '#999' }}>
									Referência
								</div>
								<div style={{ fontWeight: 600 }}>
									{item.referencia_produto || '-'}
								</div>
							</div>
						</div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between'
							}} >
							<div style={{ flex: 1, fontSize: 10 }}>
								<div style={{ color: '#999' }}>
									Quantidade
								</div>
								<div style={{ fontWeight: 600 }}>
									{FormatUtils.formatarValorTela(item.quantidade, 0)} {item.unidade_produto || '-'}
								</div>
							</div>
							<div style={{ flex: 1, textAlign: 'center', fontSize: 10 }}>
								<div style={{ color: '#999' }}>
									Valor Unitário
								</div>
								<div style={{ fontWeight: 600 }}>
									R$ {FormatUtils.formatarValorTela(item.vlr_unitario, 2)}
								</div>
							</div>
							<div style={{ flex: 1, textAlign: 'right', fontSize: 10 }}>
								<div style={{ color: '#999' }}>
									Valor Bruto
								</div>
								<div style={{ fontWeight: 600 }}>
									R$ {FormatUtils.formatarValorTela(item.valor_bruto, 2)}
								</div>
							</div>
						</div>

						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between'
							}} >
							<div style={{ flex: 1, fontSize: 11 }}>
								<div style={{ color: '#999' }}>
									Desconto
								</div>
								<div style={{ fontWeight: 600 }}>
									R$ {FormatUtils.formatarValorTela(item.vlr_desconto, 2)} ({FormatUtils.formatarValorTela(item.perc_desconto, 2)}%)
								</div>
							</div>

							<div style={{ flex: 1, textAlign: 'right', fontSize: 11 }}>
								<div style={{ color: '#999' }}>
									Valor Líquido
								</div>
								<div style={{ fontWeight: 600 }}>
									R$ {FormatUtils.formatarValorTela(
											parseFloat(item.valor_bruto || 0)
											- parseFloat(item.vlr_desconto || 0)
											, 2)}
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		);
	}

	selecionarProduto() {
		return (
			<Produto
				eventoPedido={produto => {
					this.props.initForm({
						...this.props.formularioValues,
						selecionarProduto: false
					});
					if (produto) {
						this.setModalProduto({
							id_produto: produto.id_produto,
							id_pedido: this.props.formularioValues.id,
							seq_prod: (this.props.listaItens || []).length + 1,
							id_produto: produto.id_produto,
							codigo_produto: produto.codigo,
							referencia_produto: produto.referencia,
							nome_produto: produto.descricao,
							unidade_produto: produto.unidade,
							quantidade: FormatUtils.formatarValorTela(1, 2),
							quantidade_nf: FormatUtils.formatarValorTela(1, 2),
							vlr_unitario: FormatUtils.formatarValorTela(produto.preco_venda1, 2),
							vlr_desconto: FormatUtils.formatarValorTela(0, 2),
							perc_desconto: FormatUtils.formatarValorTela(0, 2),
							valor_bruto: FormatUtils.formatarValorTela(produto.preco_venda1, 2)
						});
					}
				}} />
		);
	}

	setModalProduto(registro) {
		this.setState({
			modalProduto: registro
		});
	}

	modalProduto(readOnly) {

		if (!this.state.modalProduto) {
			return;
		}

		const registro = this.state.modalProduto;
		const produto = this.props.listaProduto.filter(item => item.id_produto == registro.id_produto)[0];

		const valorLiquido = FormatUtils.formatarValorTela(parseFloat(registro.valor_bruto || 0)
			- parseFloat(registro.vlr_desconto || 0), 2);

		return (
			<>
				<div className="modal-backdrop fade show"
					onClick={() => this.setModalProduto(null)} />
				<div class='modal fade show'
					onClick={() => this.setModalProduto(null)}
					id='modal-xl'
					style={{ display: 'block' }}
					aria-modal='true'>
					<div class='modal-dialog modal-xl'
						onClick={(e) => e.stopPropagation()}>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#1B4D3E', color: '#fff' }}>
								<h4 class='modal-title'>Produto</h4>
								<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close'
									onClick={() => this.setModalProduto(null)}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32, marginRight: 4 }}>×</span>
								</button>
							</div>
							<div class='modal-body' style={{ overflowY: 'scroll', padding: 2 }}>
								<div
									style={{
										backgroundColor: '#fff',
										borderRadius: 16,
										marginBottom: 16,
										padding: 16
									}} >
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											marginBottom: 16
										}}
									>
										{(produto && produto.imagem) &&
											<img
												src={String(produto.imagem)}
												alt='Produto'
												style={{
													width: '100%',
													height: 100,
													objectFit: 'contain',
													borderRadius: 12,
													backgroundColor: '#ffffff',
													border: '1px solid #eee',
													padding: 8
												}}
											/>}
									</div>

									<div
										style={{
											fontSize: 14,
											fontWeight: 'bold',
											color: '#333',
											marginBottom: 4
										}}
									>
										{registro.nome_produto}
									</div>
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											marginBottom: 8
										}} >
										<div>
											<div style={{ fontSize: 12, color: '#999' }}>
												Código
											</div>
											<div style={{ fontWeight: 600 }}>
												{registro.codigo_produto}
											</div>
										</div>

										<div style={{ textAlign: 'right' }}>
											<div style={{ fontSize: 12, color: '#999' }}>
												Referência
											</div>
											<div style={{ fontWeight: 600 }}>
												{registro.referencia_produto || '-'}
											</div>
										</div>
									</div>
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											marginBottom: 8
										}} >
										<div>
											<div style={{ fontWeight: 600 }}>
												
											</div>
										</div>
									</div>
								
									<Row>
										<LabelAndInputNumber
											name='vlr_unitario'
											label='Valor Unitário' placeholder='Informe'
											cols='6 6 4 3'
											casas={2}
											value={registro.vlr_unitario}
											onChange={data => {
												const quantidade = parseFloat(FormatUtils.formatarValorBanco(registro.quantidade, 2)) || 0;
												const valorUnitario = parseFloat(FormatUtils.formatarValorBanco(data.target.value, 2)) || 0;
												let valorBruto = parseFloat((quantidade * valorUnitario).toFixed(2));

												const percDesconto = parseFloat(FormatUtils.formatarValorBanco(registro.perc_desconto, 2)) || 0;
												const valorDesconto = FormatUtils.formatarValorTela(((valorBruto * percDesconto) / 100).toFixed(2), 2);

												valorBruto = FormatUtils.formatarValorTela(valorBruto, 2);

												this.setModalProduto({
													...registro,
													vlr_unitario: data.target.value,
													valor_bruto: valorBruto,
													vlr_desconto: valorDesconto
												});
											}} />

											<LabelAndInput
												name='unidade_produto'
												label='Unidade de Medida' placeholder='Informe'
												cols='6 6 4 3'
												readOnly='readOnly'
												value={registro.unidade_produto}
												onChange={() => {}} />
									</Row>
									<Row>
										<LabelAndInputNumber
											name='quantidade'
											label='Qtd.' placeholder='Informe'
											cols='4 4 4 3'
											casas={0}
											value={registro.quantidade}
											onChange={data => {
												const quantidade = parseFloat(FormatUtils.formatarValorBanco(data.target.value, 2)) || 0;
												const valorUnitario = parseFloat(FormatUtils.formatarValorBanco(registro.vlr_unitario, 2)) || 0;
												let valorBruto = parseFloat((quantidade * valorUnitario).toFixed(2));

												const percDesconto = parseFloat(FormatUtils.formatarValorBanco(registro.perc_desconto, 2)) || 0;
												const valorDesconto = FormatUtils.formatarValorTela(((valorBruto * percDesconto) / 100).toFixed(2), 2);

												valorBruto = FormatUtils.formatarValorTela(valorBruto, 2);

												this.setModalProduto({
													...registro,
													quantidade: data.target.value,
													quantidade_nf: data.target.value,
													valor_bruto: valorBruto,
													vlr_desconto: valorDesconto
												});
											}} />

										<LabelAndInputNumber
											name='quantidade_nf'
											label='Qtd. NF' placeholder='Informe'
											cols='4 4 4 3'
											casas={0}
											value={registro.quantidade_nf}
											onChange={data => {
												this.setModalProduto({
													...registro,
													quantidade_nf: data.target.value
												});
											}} />

										<LabelAndInputNumber
											name='perc_desconto'
											label='Desc. (%)' placeholder='Informe'
											cols='4 4 4 3'
											casas={2}
											textAlign='right'
											value={registro.perc_desconto}
											onChange={data => {
												const percDesconto = parseFloat(FormatUtils.formatarValorBanco(data.target.value, 2)) || 0;
												const valorBruto = parseFloat(FormatUtils.formatarValorBanco(registro.valor_bruto, 2)) || 0;
												const valorDesconto = FormatUtils.formatarValorTela(((valorBruto * percDesconto) / 100).toFixed(2), 2);

												this.setModalProduto({
													...registro,
													perc_desconto: data.target.value,
													vlr_desconto: valorDesconto
												});
											}} />
									</Row>

									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											marginBottom: 8
										}} >
										<div style={{ flex: 1 }}>
											<div style={{ fontSize: 12, color: '#999' }}>
												Valor Bruto
											</div>
											<div style={{ fontWeight: 600 }}>
												R$ {registro.valor_bruto}
											</div>
										</div>

										<div style={{ flex: 1, textAlign: 'center' }}>
											<div style={{ fontSize: 12, color: '#999' }}>
												Valor Desconto
											</div>
											<div style={{ fontWeight: 600 }}>
												R$ {registro.vlr_desconto}
											</div>
										</div>

										<div style={{ flex: 1, textAlign: 'right' }}>
											<div style={{ fontSize: 12, color: '#999' }}>
												Valor Líquido
											</div>
											<div style={{ fontWeight: 600 }}>
												R$ {valorLiquido}
											</div>
										</div>
									</div>
								</div>
							</div>
							
							{!readOnly &&
							<Row alignCenter style={{ marginBottom: 16, paddingRight: 10 }}>
								<Grid cols='6 6 4 3'>
									<Button
										text='Salvar'
										type={'success'}
										icon={'fa fa-check'}
										event={() => {
											this.props.salvarItem(registro, () => this.setModalProduto(null));
										}} />
								</Grid>
								{!!registro.id &&
								<Grid cols='6 6 4 3'>
									<Button
										text='Remover'
										type={'danger'}
										icon={'fa fa-check'}
										event={() => {
											this.props.excluirItem(registro, () => this.setModalProduto(null));
										}} />
								</Grid>}
							</Row>}
						</div>
					</div>
				</div>
			</>
		);
	}

	/*
	quantidade
	quantidade_nf
	vlr_unitario
	vlr_desconto
	perc_desconto
	valor_bruto
	*/
}

PedidoForm = reduxForm({form: 'pedidoForm', destroyOnUnmount: false})(PedidoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('pedidoForm')(state),
	registro: state.pedido.registro,
	listaItens: state.pedido.listaItens,
	listaCidade: state.pedido.listaCidade,
	listaCliente: state.cliente.lista,
    listaFormaPagamento: state.pedido.listaFormaPagamento,
    listaTipoPagamento: state.pedido.listaTipoPagamento,
    listaTipoPagamento: state.pedido.listaTipoPagamento,
	listaProduto: state.produto.lista.filter(item => item.liberado),
	listaBoletosPendentes: state.cliente.listaBoletosPendentes
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, excluir, salvarItem, excluirItem, getListaItens, getListaItensHistorico, gerarPdf,
	enviar
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoForm);
